export default __webpack_public_path__ + "static/media/A5.4e1e5a6f.png";